<template>
  <div class="impact-embed-links">
    <div class="loading" v-if="display.loaded!=true">
      <div class="load">
        <hr><hr><hr><hr>
        <div class="loadback"></div>
      </div>
    </div>
    <div style="background-color: #f1f1f1; vertical-align: middle;flex-direction: column;padding:2px 0px; display: flex; min-height: 100vh; justify-content: center;" v-if="this.isWidgetUserDowngrade === 'yes'">
      <div style=" display: flex; flex-direction:column;">
        <div style="text-align: center; font-size: 8px;color: #000;">
          Oops! Looks like your widget has been deactivated.
          Please reactivate your B1G1 membership and get your widget running again.
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-sm-12 text-center">
        <div v-if="goalWidget.width" class="graph-sec" :style="{ width: goalWidget.borderWidth + 'px', height: goalWidget.borderWidth + 'px', background: goalWidget.selectedBackgroundTheme + '!important' }">
          <div class='gauge-title'>
            <span :options="options" ref='gauge-value' v-if='top' :class='gaugeValueClass'></span>
            <span v-if='top' :class='gaugeValueClass'>{{unit}}</span>
          </div>
          <canvas :options="options" ref='gauge' :height='height' :width='width'></canvas>
          <div class='gauge-title'>
            <span ref='gauge-value' v-if='!top' :class='gaugeValueClass'></span>
            <span v-if='!top' :class='gaugeValueClass'>{{unit}}</span>
          </div>
          <aside>
            <h3 v-if="goalWidget.target">{{goalWidget.percentage}}%</h3>
            <h4 v-if="goalWidget.impacts > 0" class="timer">
              <animate-number
                from="1"
                duration="3000"
                :to="goalWidget.impacts"
                easing="easeOutQuad"
                :formatter="formatter"
                ></animate-number> impacts created
            </h4>
          </aside>
          <p  class="im-title">{{goalWidget.impactText}} GIVING GOAL</p>
          <p class="ta-title"><span v-if="goalWidget.target">{{commafy(goalWidget.target)}}</span><span v-else>-</span> IMPACTS</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import widgetAPI from '../../api/widget'
import contributionAPI from '../../api/contribution'
import moment from 'moment'
import VueAnimateNumber from 'vue-animate-number'
import { Donut } from 'gaugeJS/dist/gauge.min'
Vue.use(VueAnimateNumber)
export default {
  props: {
    unit: {
      type: String,
      default: ''
    },
    decimalPlace: {
      type: Number,
      default: 0
    },
    gaugeValueClass: {
      type: String,
      default: ''
    },
    top: {
      type: Boolean,
      default: false
    },
    maxValue: {
      type: Number,
      default: 100
    },
    minValue: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function () {
        return {
          angle: 0.3,
          radiusScale: 1,
          pointer: {
            length: 0.6,
            strokeWidth: 0.035,
            color: '#C4C4C4'
          },
          limitMax: false,
          limitMin: false,
          colorStart: '#7BD7F3',
          colorStop: '#00b4eb',
          strokeColor: '#EEEEEE',
          generateGradient: true,
          highDpiSupport: true
        }
      }
    },
    animationSpeed: {
      type: Number,
      default: 10
    },
    initialValue: {
      type: Number,
      default: 0
    },
    donut: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      gauge: null,
      value: 1,
      height: '300px',
      width: '300px',
      display: {
        loaded: false
      },
      isWidgetUserDowngrade: 'yes',
      goalWidget: {
        user_id: 0,
        impacts: 0,
        impactText: moment().endOf('year').format('YYYY'),
        percentage: 0,
        width: 300,
        borderWidth: 400,
        target: 100000,
        start_date: moment().startOf('year').format('YYYY-MM-DD'),
        end_date: moment().endOf('year').format('YYYY-MM-DD'),
        selectedBackgroundTheme: 'white'
      }
    }
  },
  beforeDestroy () {
    delete this.gauge
  },
  watch: {
    value: function (newVal) {
      if (newVal) {
        this.gauge.set(newVal)
      }
    },
    'goalWidget.percentage': {
      handler: function (newVal) {
        this.initializeGauge()
      }
    }
  },
  methods: {
    commafy (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatter: function (num) {
      return parseInt(num).toLocaleString('en')
    },
    initializeGauge () {
      if (this.$refs.gauge) {
        this.value = (this.goalWidget.percentage > 0) ? this.goalWidget.percentage : 1
        this.gauge = new Donut(this.$refs.gauge)
        this.gauge.maxValue = this.maxValue
        this.gauge.setMinValue(this.minValue)
        this.gauge.animationSpeed = this.animationSpeed
        this.gauge.setOptions(this.options)
        this.gauge.setTextField(this.$refs['gauge-value'], this.decimalPlace)
        this.gauge.set(this.value)
      }
    },
    loadGoalWidget () {
      return widgetAPI.getGoalWidgetSettingsById(this.$route.params.id).then((response) => {
        if (response) {
          if (response.status === 1) {
            this.isWidgetUserDowngrade = response.isWidgetUserDowngrade
            this.goalWidget.width = (response.width) ? response.width : '300px'
            this.goalWidget.borderWidth = parseInt(this.goalWidget.width) + 100
            this.height = this.goalWidget.width + 'px'
            this.width = this.goalWidget.width + 'px'
            this.goalWidget.user_id = response.user_id
            this.goalWidget.selectedBackgroundTheme = response.background_color
            document.querySelector('body').style.backgroundColor = response.background_color
            let userJoinDateYear = moment(response.user_join_date).format('YYYY')
            let currentDateYear = moment().startOf('year').format('YYYY')
            if (userJoinDateYear === currentDateYear) {
              this.goalWidget.start_date = moment(response.user_join_date).format('YYYY-MM-DD')
            }
            if (response.start_date) {
              this.goalWidget.start_date = moment(response.start_date).format('YYYY-MM-DD')
            }
            if (response.end_date) {
              this.goalWidget.end_date = moment(response.end_date).format('YYYY-MM-DD')
            }
            this.goalWidget.impactText = moment(this.goalWidget.end_date).format('YYYY')
            this.goalWidget.target = (response.target) ? response.target : this.goalWidget.target
            this.loadFilterGoalImpactData()
          }
        }
      })
    },
    loadFilterGoalImpactData () {
      let startDate = moment(this.goalWidget.start_date).format('YYYY-MM-DD')
      let endDate = moment(this.goalWidget.end_date).format('YYYY-MM-DD')
      contributionAPI.get({current_user_id: this.goalWidget.user_id, date_start: startDate, date_end: endDate, impact_type: 'company', limit: -1}, ['Impact', 'Project', 'Story'], 'not').then((response) => {
        this.goalWidget.impacts = response.length > 0 ? response.map(i => i.beneficiaries).reduce((p, n) => p + n) : 0
        if (this.goalWidget.target) {
          if (this.goalWidget.impacts === 0) {
            this.goalWidget.percentage = 0
          } else {
            if (this.goalWidget.target >= this.goalWidget.impacts) {
              this.goalWidget.percentage = ((this.goalWidget.impacts / this.goalWidget.target) * 100).toFixed(1)
            } else {
              this.goalWidget.percentage = 100
            }
          }
        }
        this.value = (this.goalWidget.percentage > 0) ? this.goalWidget.percentage : 1
      })
    }
  },
  created () {
    let goalWidgetPromise = this.loadGoalWidget()

    Promise.all([goalWidgetPromise]).then(() => {
      this.display.loaded = true
      let currentThis = this
      setTimeout(function () {
        document.documentElement.style.overflow = 'hidden'
        currentThis.initializeGauge()
      }, 1000)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/ImpactGoalWidget.vue